import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
// import CodeIcon from '@mui/icons-material/Code';
//
import Editor from '../editor';

// ----------------------------------------------------------------------

export default function RHFEditor({ name, helperText, ...other }) {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  const values = watch();
  const [showSource, setShowSource] = useState(false);
  const [sourceCode, setSourceCode] = useState('');

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  const handleToggleSource = (currentValue) => {
    if (!showSource) {
      // Switching to source view - save current HTML
      setSourceCode(currentValue || '');
    } else {
      // Switching back to visual editor - update value from source
      setValue(name, sourceCode, {
        shouldValidate: true,
      });
    }
    setShowSource(!showSource);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (

        <Box>
          {/* Toggle Button */}
          <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
            <Button
              size="small"
              variant={showSource ? 'contained' : 'outlined'}
              // startIcon={<CodeIcon />}
              onClick={() => handleToggleSource(field.value)}
              sx={{ textTransform: 'none' }}
            >
              {showSource ? 'Visual Editor' : 'Source Code'}
            </Button>
          </Stack>


          {/* Visual Editor */}
          {!showSource ? (
            <Editor
              id={name}
              value={field.value}
              onChange={field.onChange}
              error={!!error}
              helperText={
                (!!error || helperText) && (
                  <FormHelperText error={!!error} sx={{ px: 2 }}>
                    {error ? error?.message : helperText}
                  </FormHelperText>
                )
              }
              {...other}
            />
          ) : (
            // HTML Source Code Editor
            <Box>
              <TextField
                multiline
                rows={20}
                fullWidth
                value={sourceCode}
                onChange={(e) => setSourceCode(e.target.value)}
                placeholder="Paste or edit HTML code here..."
                error={!!error}
                // sx={{
                //   '& .MuiInputBase-root': {
                //     fontFamily: 'Monaco, Menlo, "Ubuntu Mono", Consolas, monospace',
                //     fontSize: '0.875rem',
                //     lineHeight: 1.6,
                //   },
                //   '& .MuiInputBase-input': {
                //     padding: '12px',
                //   },
                // }}
                // InputProps={{
                //   style: {
                //     backgroundColor: '#f5f5f5',
                //   },
                // }}
              />
              {(!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2, mt: 1 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )}
            </Box>
          )}
          {/* <Editor
            id={name}
            value={field.value}
            onChange={field.onChange}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          /> */}

        </Box>
      )
      }
    />
  );
}

RHFEditor.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string,
};
